import audio1 from '../../../../assets/sounds/adult/se/diktat/trial1.mp3';
import audio2 from '../../../../assets/sounds/adult/se/diktat/trial2.mp3';

const audioFiles = {
	1: audio1,
	2: audio2,
};
export default audioFiles;
